<template>
  <a-checkbox-group
    v-model:value="innerValue"
    :disabled="disabled"
    :options="normalizedOptions.length ? normalizedOptions : undefined"
    :name="name"
    class="ant-checkbox-group-wrap"
    @change="onChange"
  >
    <slot />
  </a-checkbox-group>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { SelectOption } from "./types";

interface Props {
  modelValue?: Array<string | number | boolean>;
  options?: SelectOption[];
  disabled?: boolean;
  name?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  options: () => [],
  disabled: false,
  name: undefined,
});

const emit = defineEmits<{
  (e: "update:modelValue", value: Array<string | number | boolean>): void;
  (e: "change", value: Array<string | number | boolean>): void;
}>();

const normalizedOptions = computed(() =>
  (props.options || []).map((opt) => ({
    label: opt.label,
    value: opt.value,
    disabled: opt.disabled,
  }))
);

const innerValue = computed({
  get: () => props.modelValue ?? [],
  set: (val: Array<string | number | boolean>) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (val: Array<string | number | boolean>) => {
  emit("update:modelValue", val);
  emit("change", val);
};
</script>

<style scoped>
.ant-checkbox-group-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}
</style>

<!--
  Hướng dẫn sử dụng — Checkbox Group
  Global: <h-checkboxGroup v-model="checked" :options="[{ label: 'A', value: 1 }]" />
  Import: import { CheckboxGroup } from '@/components/ant/select'

  Props: modelValue (array), options, disabled, name
  Events: update:modelValue, change
  Docs: src/components/ant/select/README.md
-->
